import { NgModule, ModuleWithProviders } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ZoomUiModule } from 'zoom-ui-lib';
import { CommonLibModule } from 'common-lib';

import { FullCalendarModule } from '@fullcalendar/angular'; // the main connector. must go first
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';

FullCalendarModule.registerPlugins([
    // register FullCalendar plugins
    dayGridPlugin,
    interactionPlugin,
    listPlugin
]);

import { WizardComponent } from './wizard.component';
import { BaseComponent } from './components/base/base.component';
import {
    WizardActionsComponent,
    UrlListComponent,
    BannerComponent,
    DatePickerComponent,
    DateRangeComponent,
    SearchComponent,
    SelectionComponent,
    MeetingTitleComponent,
    MeetingTypeDropdownComponent,
    DurationComponent,
    TimePickerComponent,
    QuickDatesComponent,
    ReschedulePickerComponent,
    LocationComponent,
    RoomComponent,
    SuggestionsComponent,
    ConfirmationComponent,
    BookingConfirmationComponent,
    ChangeAttendeesConfirmationComponent,
    CompletionComponent,
    ClassCompletionComponent,
    GenericInputComponent,
    DividerComponent,
    VideoProviderDisplayComponent,
    ExternalOnBehalfComponent,
    SpecificDatePickerComponent,
    MaxAttendeesComponent
} from './components';
import {
    AvailabilityCalendarComponent,
    BulmaModalComponent,
    DateRangeComponent as CommonDateRangeComponent,
    DateRangeCalendarComponent,
    ErrorComponent,
    FallbackComponent,
    LabeledFieldComponent,
    TimeRangeComponent,
    TooltipComponent
} from './components/common';
import { FormDirective } from './directives/form/form.directive';
import { CheckIsVIPPipe } from './pipes/check-is-vip.pipe';

import { WizardService } from './services/wizard/wizard.service';
import { EventService } from './services/event/event.service';
import { WizardBuilderService } from './services/wizard-builder/wizard-builder.service';
import { ErrorService } from './services/error/error.service';
import { TimeRangeService } from './services/time-range/time-range.service';

@NgModule({
    declarations: [
        WizardComponent,
        // Common components
        AvailabilityCalendarComponent,
        BulmaModalComponent,
        CommonDateRangeComponent,
        DateRangeCalendarComponent,
        ErrorComponent,
        FallbackComponent,
        LabeledFieldComponent,
        TimeRangeComponent,
        TooltipComponent,
        // Components
        WizardActionsComponent,
        UrlListComponent,
        BannerComponent,
        DatePickerComponent,
        DateRangeComponent,
        SearchComponent,
        SelectionComponent,
        MeetingTitleComponent,
        MeetingTypeDropdownComponent,
        DurationComponent,
        TimePickerComponent,
        QuickDatesComponent,
        ReschedulePickerComponent,
        LocationComponent,
        RoomComponent,
        SuggestionsComponent,
        ConfirmationComponent,
        BookingConfirmationComponent,
        ChangeAttendeesConfirmationComponent,
        CompletionComponent,
        GenericInputComponent,
        DividerComponent,
        VideoProviderDisplayComponent,
        ExternalOnBehalfComponent,
        BaseComponent,
        ReschedulePickerComponent,
        SpecificDatePickerComponent,
        BookingConfirmationComponent,
        ClassCompletionComponent,
        MaxAttendeesComponent,
        // Directives
        FormDirective,
        // Pipes
        CheckIsVIPPipe
    ],
    imports: [
        ReactiveFormsModule,
        CommonModule,
        FormsModule,
        UIRouterModule,
        CommonLibModule,
        ZoomUiModule,
        FullCalendarModule
    ],
    exports: [WizardComponent]
})
export class WizardModule {
    public static forRoot(environment: any): ModuleWithProviders<WizardModule> {
        return {
            ngModule: WizardModule,
            providers: [
                WizardService,
                EventService,
                WizardBuilderService,
                ErrorService,
                TimeRangeService,
                {
                    provide: 'env', // you can also use InjectionToken
                    useValue: environment
                }
            ]
        };
    }
}
